import { SidebarSimple } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import type { Abilities } from "~/api/types";
import { IconButton } from "~/foundation/components/IconButton";
import { Tooltip } from "~/foundation/components/Tooltip";
import { isNavItemActive, visibleNavSections } from "~/shell/nav";
import { SidebarLink } from "~/shell/Sidebar/SidebarLink";

export interface RailProps {
  abilities: Abilities;
  pathname: string;
  onExpand: () => void;
}

/** The 48px collapsed sidebar: same links, labels demoted to tooltips. */
export function Rail({ abilities, pathname, onExpand }: RailProps) {
  const { t } = useTranslation();
  const sections = visibleNavSections(abilities);

  return (
    <nav aria-label={t("Main")} className="flex h-full flex-col items-center gap-1 py-2">
      <Tooltip content={t("Expand sidebar")} shortcut={["Meta", "."]} placement="inline-end">
        <IconButton icon={SidebarSimple} aria-label={t("Expand sidebar")} onClick={onExpand} />
      </Tooltip>

      <div className="mt-1 h-px w-6 bg-divider" />

      {sections.map((section) => (
        <div key={section.id} className="flex flex-col items-center gap-1">
          {section.items.map((item) => (
            <SidebarLink
              key={item.id}
              to={item.to}
              icon={item.icon}
              label={t(item.title)}
              active={isNavItemActive(item, pathname)}
              collapsed
              {...(item.disabled ? { disabled: true } : {})}
            />
          ))}
        </div>
      ))}
    </nav>
  );
}
